export default {
	page: "Página",
	of: "de",
	itemsPerPage: "Elementos por página",
	totalItems: "Mostrando {start} a {end} de {total} registros",
};
